// extracted by mini-css-extract-plugin
module.exports = {"container":"CommonCheckbox-module--container--1HWIE","checkmark":"CommonCheckbox-module--checkmark--2QeaP"};